import type { TelemetrySource, TelemetryType } from '../constants';
import type { UserOrgId } from '../../types/api/v1/obt/common/user_org_id';

export interface CommonTelemetry {
  type?: TelemetryType;
  userOrgId?: UserOrgId;
  userRoles?: string[];
  category?: TelemetrySource;
  applicationId?: string;
  isImpersonationSession?: boolean;
}

export type UIEvent = {
  uiEventType: EUiEventType;
  // For recording what DOM event (https://www.w3.org/TR/uievents/) or other logical events that trigger the segment.io data cpature.
};

/**
 * Represents a UI event type.
 */
export enum EUiEventType {
  CLICK = 'click',
  PRESS = 'press',
  MOUNT = 'mount',
  DEPS_CHANGE = 'deps-change',
  SWIPE_LEFT = 'swipe-left',
  UNKNOWN = 'unknown',
}
